import * as yup from 'yup';

export const initialValues = {
  sessionName: '',
  sessionDate: '',
  sessionOwner: '',
  sessionSubject: '',
};

export const validationSchema = yup.object().shape({
  sessionName: yup.string().required('Session Name is required'),
  sessionDate: yup.string().required('Session Date is required'),
  sessionOwner: yup.string().required('Session Owner is required'),
  sessionSubject: yup.string().required('Session Subject is required'),
});
